<template>
  <div class="container sv023">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>ご登録口座へのお振込み</HeadingOne>

    <p>
      パソコン・スマートフォンがあれば、簡単なお手続きでご登録いただいた口座へのお振込みが可能です。振込手数料はかかりません。
    </p>

    <TableBox class="_mb-20">
      <TableBody>
        <TableRow>
          <TableHeader>お振込み可能時間</TableHeader>
          <TableData>
            午前4：00～翌午前2：00まで<br />※日中時間帯はご利用いただけます。
          </TableData>
        </TableRow>
      </TableBody>
    </TableBox>

    <P>＜ご注意＞</P>
    <p>下記メンテナンス時間は、お申し込みができません。</p>
    <ListGroup class="-normal">
      <ListItem class="-normal">ご利用いただけない時間帯および特定日</ListItem>
    </ListGroup>
    <ListGroup class="_mb-md-60 _mb-sm-40">
      <ListItem>毎日深夜2:00～4:00</ListItem>
      <ListItem>毎週日曜日19:00～翌月曜日8:00</ListItem>
      <ListItem>年始1月1日～3日、ゴールデンウィーク5月3日～5日</ListItem>
      <ListItem
        >また、ご利用されている金融機関が営業時間外の場合にはお振込みができません。</ListItem
      >
    </ListGroup>

    <!--<ListGroup class="-note _mb-md-60 _mb-sm-40">-->
    <!--<ListItem class="-note">年末年始などの特定日や、メンテナンス時間帯はご利用いただけません。他のお借り入れ方法にてご利用ください。</ListItem>-->
    <!--<ListItem class="-note">ご利用されている金融機関によってお振込み可能な時間が異なります。</ListItem>-->
    <!--<ListItemp>＜ご利用いただけない時間帯および特定日＞<br>毎日深夜2:00～4:00<br>毎週日曜日19:00～翌月曜日8:00<br>年始1月1日～3日、ゴールデンウィーク5月3日～5日</ListItemp>-->
    <!--</ListGroup>-->

    <!--<sv023-header></sv023-header>-->
    <section>
      <StepList type="sv" class="_mb-md-60 _mb-sm-20 -orange">
        <HeadingTwo>口座へのお振込みによるお借り入れ方法</HeadingTwo>
        <StepItem
          number="1"
          title="会員さま専用サイトへログイン"
          src="sv/sv023/step1.jpg"
          src-sp="sv/sv023/sp/step1.jpg"
        >
          <p>会員さま専用サイトへログインします。</p>
          <ListGroup class="-note">
            <ListItem class="-note"
              >au PAY スマートローンアプリでもお手続きが可能です。</ListItem
            >
          </ListGroup>
          <BtnMain class="-normal" router-name="ce001">
            会員さま専用サイトへ
          </BtnMain>
        </StepItem>
        <StepItem
          number="2"
          title="「ご登録口座へのお振込み」を選択"
          src="sv/sv023/step2.jpg"
          src-sp="sv/sv023/sp/step2.jpg"
        >
          <p>
            会員さま専用サイトのお借り入れメニュー内より「ご登録口座へのお振込み」を選択ください。
          </p>
        </StepItem>
        <StepItem
          number="3"
          title="暗証番号認証とSMS認証後、お借り入れ金額をご入力のうえ「お申し込み」を押下"
          src="sv/sv023/step3.jpg"
          src-sp="sv/sv023/sp/step3.jpg"
          class="-last"
        >
          <p>
            暗証番号認証とSMS認証後、お借り入れ金額をご入力のうえ、確認画面に進み「お申し込み」ボタンを押してください。
          </p>
          <ListGroup class="-note _mb-md-20 _mb-sm-20">
            <ListItem class="-note">SMS認証について詳細は<router-link :to="{ name: 'sv060' }" class="-link">こちら</router-link></ListItem>
          </ListGroup>
          <BtnMain class="-normal -md" router-name="ce001">
            口座のご登録・変更はこちらから
          </BtnMain>
        </StepItem>
        <StepFooter>
          <template #heading>お手続き完了</template>
        </StepFooter>
      </StepList>
    </section>

    <section>
      <HeadingTwo>ご利用可能な金融機関</HeadingTwo>
      <p>お借り入れ・ご返済の際にご利用いただける金融機関を紹介しています。</p>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal" router-name="sv018">
          ご利用可能な金融機関へ
        </BtnMain>
      </BtngroupSingle>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import CvBox from "@/components/box/CvBox";
// import CardBox from '@/components/card/CardBox'
// import CardHeader from '@/components/card/CardHeader'
// import CardBody from '@/components/card/CardBody'
import ContactBox from "@/components/box/ContactBox";

export default {
  name: "Sv023",
  components: {
    BreadcrumbGroup,
    ContactBox,
    // CardBody,
    // CardHeader,
    // CardBox,
    CvBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtngroupSingle,
    BtnMain,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "ご登録口座へのお振込み｜お借り入れ方法",
      description:
        "ご登録の口座へのお振込みによるお借り入れ方法をご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,登録口座",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お借り入れについて",
          routerName: "sv046",
        },
        {
          text: "ご登録口座へのお振込み",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
a {
  &.-link {
    text-decoration: underline;
  }
}
</style>
